import { InitOverrideFunction, UserBudgetReadModel, UserPermissionsDto, UsersCurrentApi } from "../../../@api";

export class CurrentUserApiService implements Omit<
  UsersCurrentApi,
  `${string}Raw` | "withMiddleware" | "withPreMiddleware" | "withPostMiddleware"
> {
  constructor(private readonly api: UsersCurrentApi) {}

  public usersCurrentGetPermissions(initOverrides?: RequestInit | InitOverrideFunction): Promise<UserPermissionsDto> {
    return this.api.usersCurrentGetPermissions(initOverrides);
  }

  public usersCurrentBudget(initOverrides?: RequestInit | InitOverrideFunction): Promise<UserBudgetReadModel> {
    return this.api.usersCurrentBudget(initOverrides);
  }
}
